import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import Processo from '../../model/processo/Processo';
import { ProcessoViewModel } from '../../viewmodel/ProcessoViewModel';

interface ProcessoContextProps {
  processo: Processo | null;
  setProcesso: React.Dispatch<React.SetStateAction<Processo | null>>;  
}

const ProcessoContext = createContext<ProcessoContextProps | undefined>(undefined);

interface ProcessoProviderProps {
  children: ReactNode;
  processoId: string;
}

export const ProcessoUsuarioProvider: React.FC<ProcessoProviderProps> = ({ children, processoId }) => {
  const [processo, setProcesso] = useState<Processo | null>(null);

  useEffect(() => {
    const carregarProcesso = async () => {
      try {
        const processo = await ProcessoViewModel.obterProcessoPorId(processoId);
        setProcesso(processo);
      } catch (error) {
        console.error('Falha ao carregar o processo:', error);
      }
    };

    carregarProcesso();
  }, [processoId]);

  return (
    <ProcessoContext.Provider value={{ processo, setProcesso }}>
      {children}
    </ProcessoContext.Provider>
  );
};

export const useProcessoContext = () => {
  const context = useContext(ProcessoContext);
  if (!context) {
    throw new Error('useProcessoContext must be used within a ProcessoProvider');
  }
  return context;
};
